export const API_ENDPOINTS = {

    // ================= IDENTITY =================
    IDENTITY: {
        READ: '/secureblockchain/identity/read',
        GET: '/secureblockchain/identity/get',
        SEARCH: '/secureblockchain/identity/search',
        CREATE: '/secureblockchain/identity/create',
        UPDATE: '/secureblockchain/identity/update',
        REVOKE: '/secureblockchain/identity/revoke',
        MERGED: '/secureblockchain/identity/merged'
    },

    // ================= ACCESS FLOW =================
    ACCESS_FLOW: {
        GET: '/secureblockchain/accessflow/get',
        SEARCH: '/secureblockchain/accessflow/search',
        SEARCH_ALL: '/secureblockchain/accessflow/searchall',
        MISSING: '/secureblockchain/accessflow/missing',
        CREATE: '/secureblockchain/accessflow/create'
    },

    // ================= CONTRACT MANAGEMENT =================
    CONTRACT: {
        DEPLOY: '/secureblockchain/contract/deploy',
        STATUS: '/secureblockchain/contract/status',
        UPDATE: '/secureblockchain/contract/update',
        DELETE: '/secureblockchain/contract/delete'
    },

    // ================= CONTRACT OPERATION =================
    OPERATION: {
        READ: '/secureblockchain/operation/read',
        SEARCH: '/secureblockchain/operation/search',
        SUBMIT: '/secureblockchain/operation/submit',
        READALL: '/secureblockchain/operation/readall'
    },

    // ================= CONTRACT VIEW =================
    VIEW: {
        READ: '/secureblockchain/view/read',
        SEARCH: '/secureblockchain/view/search',
        KEYS: '/secureblockchain/view/keys',
        HISTORY: '/secureblockchain/view/history'
    },

    ASSET: {
        FETCHREMACCESSFLOWASSETS: "/asset/fetchremainingassetsaccessflow",
        SEARCHREMACCESSFLOWASSETS: "/asset/searchremainingassetsaccessflow",
        GENERATEREMAININGASSETSACCESSFLOW: "/asset/generateremainingassetsaccessflow"
    },
    DASHBOARD: {
        FETCH: "/secureblockchain/dashboard/summary"
    }
};